import { render, staticRenderFns } from "./AuthenticateToken.vue?vue&type=template&id=339a57c7&"
import script from "./AuthenticateToken.vue?vue&type=script&lang=js&"
export * from "./AuthenticateToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports